import React from 'react';
import { HeadingBlock } from '../HeadingBlock';
import { IconAndTitle } from '../../shared/IconAndTitle';
import { HydratedBlockProps } from '../../BaseBlock';

export type HeadingEditorSettingsProps = {
  block: HeadingBlock & HydratedBlockProps;
};

export function HeadingEditorSettings({
  block,
}: HeadingEditorSettingsProps): JSX.Element {
  return (
    <>
      <IconAndTitle icon={block.icon} title={block.title} />
      <hr />
    </>
  );
}
